import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Reset viewport scroll on client route changes (replaces Next.js scroll restoration). */
export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.getElementById("main-content")?.scrollTo?.(0, 0);
  }, [pathname, search]);

  return null;
}
